import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, Type } from '@angular/core';
import { IframeActivityModalBase } from '../../shared/iframe-activity-modal/iframe-activity-modal.base';
import { ModalService } from '../../shared/modal.service';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';
import { ImmersionTileModalData } from './immersion-tile-modal-data';

@Component({
  selector: 'lp2-immersion-tile',
  templateUrl: './immersion-tile.component.html',
  styleUrls: ['./immersion-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImmersionTileComponent {
  @Input() item: StudyBundleCourseDto;
  @Input() modalComponent: Type<IframeActivityModalBase>;
  @Input() windowClass: string;
  @Input() idPrefix: string;
  @Input() modalData: ImmersionTileModalData;
  @Input() ariaLabelledBy: string;
  @Input() showCompleteLabel = false;
  @Output() playerClosed = new EventEmitter<number>();

  constructor(private readonly modalService: ModalService) {}

  play(): void {
    const modalRef = this.modalService.openModalWithInjectData(
      this.modalComponent,
      { item: this.item, ...this.modalData },
      this.windowClass,
      this.ariaLabelledBy
    );
    modalRef.result.then(() => {
      this.playerClosed.emit(this.item.id);
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/immersion-tile/immersion-tile.component.ts